export default __webpack_public_path__ + "static/media/icon-caret-up.ccfcf03a.svg";